import PropTypes from 'prop-types';
import { Container, Typography } from '@mui/material';
import { AppResponsiveContainer } from '../containers/AppResponsiveContainer';
import React, { forwardRef } from 'react';
import AppCardView from './AppCardView';
import AppText from 'components/widgets/AppText';

const AppSectionView = forwardRef(({
    title,
    description,
    items,
    renderItem = (item, index) => <AppCardView {...item} key={index} sx={{ height: '100%' }} />,
    spacing = 4,
    maxWidth = 'lg',
    py = 8,
    titleProps = {},
    descriptionProps = {},
    containerProps = {},
    itemContainerProps = {},
}, ref) => {
    return (
        <Container ref={ref} maxWidth={maxWidth} sx={{ py, ...containerProps }}>
            {title && (
                <Typography
                    variant="h3"
                    align="center"
                    gutterBottom
                    {...titleProps}
                >
                    {title}
                </Typography>
            )}
            {description && (
                <AppText color="text.secondary" text = {description} mb = {2} {...descriptionProps} />
            )}
            <AppResponsiveContainer spacing={spacing} {...itemContainerProps}>
                {items.map((item, index) => renderItem(item, index))}
            </AppResponsiveContainer>
        </Container>
    );
});

AppSectionView.propTypes = {
    title: PropTypes.string,
    items: PropTypes.array.isRequired,
    renderItem: PropTypes.func.isRequired,
    spacing: PropTypes.number,
    maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false]),
    py: PropTypes.number,
    titleProps: PropTypes.object,
    containerProps: PropTypes.object,
};

export { AppSectionView }
